// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/yovo-tokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

/*
 * Document scroll must live on <html> only. Putting overflow-x on #root/body together
 * with min-height layouts fights MUI CssBaseline and breaks the main scrollbar (Chrome/Safari).
 * Horizontal bleed is clipped on html; body/#root stay overflow visible vertically.
 * Use clip (not hidden) on x-axis — hidden breaks position:fixed bottom bars on iOS Safari.
 */
html {
  overflow-x: clip;
  /* Keep the vertical scrollbar always visible so opening dropdowns / date pickers
     never hides it (no shift, no empty gutter strip). */
  overflow-y: scroll;
  text-size-adjust: 100%;
}

body {
  margin: 0;
  min-height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  min-height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;EAKE;AACF;EACE,gBAAgB;EAChB;wDACsD;EACtD,kBAAkB;EAElB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb","sourcesContent":["@import './styles/yovo-tokens.css';\n\n* {\n  box-sizing: border-box;\n}\n\n/*\n * Document scroll must live on <html> only. Putting overflow-x on #root/body together\n * with min-height layouts fights MUI CssBaseline and breaks the main scrollbar (Chrome/Safari).\n * Horizontal bleed is clipped on html; body/#root stay overflow visible vertically.\n * Use clip (not hidden) on x-axis — hidden breaks position:fixed bottom bars on iOS Safari.\n */\nhtml {\n  overflow-x: clip;\n  /* Keep the vertical scrollbar always visible so opening dropdowns / date pickers\n     never hides it (no shift, no empty gutter strip). */\n  overflow-y: scroll;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  min-height: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  min-height: 100%;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
